import { useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from '@paysense-india-services/elevate-web'

import { ROUTES } from '@/constants/routes'

import CardComponent from '@/components/CardComponent'
import Section from '@/components/Section'

import EmiDetailHeader from './components/EmiDetailHeader'
import EmiDetailRow from './components/EmiDetailRow'

const EmiDetail = ({ data }) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const loanId = searchParams.get('loan_id') || searchParams.get('loanId')

  const handleFooterClick = () => {
    if (data?.actions?.primary?.type === 'SEE_SECHEDULE') {
      const query = loanId ? `?loan_id=${encodeURIComponent(loanId)}` : ''
      navigate(`${ROUTES.EMI_SCHEDULE}${query}`)
    }
  }

  const renderComponent = component => {
    switch (component?.type) {
      case 'emi_detail_header':
        return null
      case 'emi_detail_row':
        return <EmiDetailRow data={component} />
      default:
        return null
    }
  }
  const headerData = data?.components?.items?.find(
    component => component?.type === 'emi_detail_header'
  )

  const footerData = data?.actions?.primary?.text ? (
    <Button
      className='ew-bg-primary ew-color-brand ew-w-100 ew-mt-8'
      onClick={handleFooterClick}
      size='medium'>
      {data.actions.primary.text}
    </Button>
  ) : null

  return (
    <Section title={data?.title}>
      <CardComponent
        footer={footerData}
        header={headerData ? <EmiDetailHeader data={headerData} /> : null}>
        <div className='ew-d-flex ew-flex-column ew-gap-12'>
          {data?.components?.items?.map((component, index) => (
            <div key={component.type || index}>{renderComponent(component)}</div>
          ))}
        </div>
      </CardComponent>
    </Section>
  )
}

export default EmiDetail
